import { create } from 'zustand';

interface ValuesVisibilityStore {
  isVisible: boolean;
  toggle: () => void;
}

export const useValuesVisibility = create<ValuesVisibilityStore>((set) => ({
  isVisible: false,
  toggle: () => set((state) => ({ isVisible: !state.isVisible })),
}));
